export default {
  get apiUrl () {
    // let useSslDev = false
    // let useSslProd = true
    return 'https://2ris0v850m.execute-api.us-east-1.amazonaws.com/Prod/api/market'
    // return process.env.NODE_ENV === 'production'
    //   ? (useSslProd === true ? 'https://g7nag2z4v8.execute-api.us-east-2.amazonaws.com/Prod/api/market' : 'http://g7nag2z4v8.execute-api.us-east-2.amazonaws.com/Prod/api/market')
    //   : (useSslDev === true ? 'https://localhost:9443/api/market' : 'http://localhost:9000/api/market')
  },
  get stripeKey () {
    return 'pk_test_cNJbiA1YaOzqEjkqykEO6zmd'
  },
  get stripeOptions () {
    return { style: { base: { fontFamily: 'Roboto,sans-serif' } }, hidePostalCode: true }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/config.js